import { ParticipantPortal, Widget } from "@/components/services/participant-service";

export default {
  props: {
    lang: {
      type: String,
      default: "EN"
    }
  },
  data: () => {
    return {
      widgets: new Widget(),
      participantportal: new ParticipantPortal(),
      activity: null
    };
  },
  computed: {
    selectedActivity() {
      this.activity = this.$store.getters.getSelectedActivity.data;
      return this.activity;
    },
    translationKeyInitial() {
      return this.isLegacyStudy ? `${this.question.guid || this.question.identifier}` : `${this.selectedActivity.revisionId || this.selectedActivity.activityId}_${this.question.identifier}`;
    },

    singleTranslationKey() {
      const id = this.selectedActivity.revisionId || this.selectedActivity.activityId;
      return `${id}`;
    }
  },
  methods: {
    translateToActiveLang(key, defaultText, params = null) {
      let translatedText = this.widgets.i18nActivities(key, this.lang);
      if (translatedText) {
        if (!!params && typeof params === "object") {
          Object.keys(params).forEach(paramKey => {
            if (translatedText.indexOf(`[${paramKey}]`) >= 0) {
              translatedText = translatedText.replace(`[${paramKey}]`, params[paramKey]);
            }
          });
        }
        return translatedText;
      }
      return defaultText;
    },

    setQuestionText() {
      if (!["SurveyInstruction", "Section"].includes(this.question.constraints.type)) {
        const translatedQuestionText = this.translateToActiveLang(`${this.translationKeyInitial}_formattedBody`, this.question.formattedBody);

        this.$set(this.question, "displayQuestionText", translatedQuestionText);
      }
    }
  },

  mounted() {
    // Set the Translated text for the Question
    this.setQuestionText();
  }
};
